namespace Matrix.Data {
    export interface ExtensionFieldRetrieveRequest extends Serenity.ServiceRequest {
        TableSchema?: string;
        Tablename?: string;
        FieldName?: string;
    }
}
